// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PMBjioMJPJUh2dDz77eQ{margin-top:16px}`, "",{"version":3,"sources":["webpack://./src/elements/velavu-alert-modal/velavu-alert-modal-text-confirm.module.scss"],"names":[],"mappings":"AAAA,sBACC,eAAA","sourcesContent":[".textInput {\n\tmargin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export var textInput = `PMBjioMJPJUh2dDz77eQ`;
export default ___CSS_LOADER_EXPORT___;
